// extracted by css-extract-rspack-plugin
var _1 = "EM8wo";
var _2 = "Hr3aY";
export { _1 as "moveToMenu", _2 as "moveToMenuSweepDialog" }
